export default {
      id: "cell_tower-usage",
      viewBox: "0 0 33 46",
      url: __webpack_public_path__ + "img/icons.svg#cell_tower",
      toString: function () {
        return this.url;
      }
    }